import React, { useState, useEffect } from 'react'
import logo from '../img/logo1.png';
import { 
  FaTachometerAlt, 
  FaSearch, 
  FaHotel, 
  FaBoxOpen, 
  FaSignOutAlt,
  FaChevronDown,
  FaChevronRight,
  FaPlus,
  FaList,
  FaEye
} from 'react-icons/fa';

export default function Sidebar() {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [hoveredDashboard, setHoveredDashboard] = useState(false);

  // Function to toggle dropdown
  const toggleDropdown = (section) => {
    if (activeDropdown === section) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(section);
    }
  };

  // Set initial active dropdown based on current page
  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('seo')) setActiveDropdown('seo');
    else if (path.includes('hotel')) setActiveDropdown('hotel');
    else if (path.includes('package')) setActiveDropdown('package');
  }, []);

  // Check if current page is active
  const isActive = (path) => {
    return window.location.pathname.includes(path);
  };

  return (
    <>
    <nav className="sidebar" style={{ 
      background: '#ffffff', 
      borderRight: '1px solid #e9ecef',
      boxShadow: '2px 0 10px rgba(0,0,0,0.03)'
    }}>
      {/* Logo Header */}
      <div className="sidebar-header" style={{ 
        padding: '25px 15px', 
        background: 'white', 
        borderBottom: '1px solid #e9ecef',
        textAlign: 'center',
          justifyContent: 'center',
  alignItems: 'center',

          display: 'flex'

      }}>
        <a href="../index.html" className="sidebar-brand">
          <img src={logo} alt="logo"   style={{ 
        width: '100%',  // Makes logo responsive to container width
        maxWidth: '180px',  // Increased from 130px
        height: 'auto',
        display: 'block',
        margin: '0 auto'
      }}  />
        </a>
      </div>

      {/* Navigation */}
      <div className="sidebar-body" style={{ padding: '12px' }}>
        <ul className="nav flex-column">
          {/* Dashboard */}
        {/* Dashboard */}
<li className="nav-item mb-2">
  <a 
    href="main" 
    className="nav-link d-flex align-items-center"
    style={{ 
      padding: '1px 10px',
      borderRadius: '6px',
      background: hoveredDashboard ? '#C99A3A' : '#059e98', // Teal normally, Brown on hover
      color: 'white', // ALWAYS white text
      fontWeight: '500',
      transition: 'all 0.2s ease',
      fontSize: '0.9rem',
      textDecoration: 'none'
    }}
    onMouseEnter={() => setHoveredDashboard(true)}
    onMouseLeave={() => setHoveredDashboard(false)}
  >
    <FaTachometerAlt style={{ 
      fontSize: '1.5rem',
      color: 'white', // Icon ALWAYS white
      marginRight: '15px',
      marginLeft: '10px',
      flexShrink: 0
    }} />
    <span>Dashboard</span>
  </a>
</li>

          {/* SEO Section */}
          <li className="nav-item mb-2">
            <div 
              className="d-flex align-items-center justify-content-between"
              style={{
                cursor: 'pointer',
                borderRadius: '6px',
                padding: '8px 10px',
                background: activeDropdown === 'seo' ? '#f8f9fa' : 'transparent',
                border: activeDropdown === 'seo' ? '1px solid #e9ecef' : 'none',
                fontSize: '0.9rem',
                transition: 'all 0.2s ease'
              }}
              onClick={() => toggleDropdown('seo')}
              onMouseEnter={(e) => {
                if (activeDropdown !== 'seo') {
                  e.currentTarget.style.background = '#f8f9fa';
                }
              }}
              onMouseLeave={(e) => {
                if (activeDropdown !== 'seo') {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              <div className="d-flex align-items-center">
                <FaSearch style={{ 
                  color: '#059e98', 
                  fontSize: '0.9rem',
                  marginRight: '8px',
                  flexShrink: 0
                }} />
                <span style={{ fontWeight: '500', color: '#333' }}>SEO</span>
              </div>
              {activeDropdown === 'seo' ? 
                <FaChevronDown size={11} color="#666" /> : 
                <FaChevronRight size={11} color="#666" />
              }
            </div>
            
            {activeDropdown === 'seo' && (
              <div className="mt-1" style={{ fontSize: '0.85rem', paddingLeft: '26px' }}>
                <a 
                  href="addseo" 
                  className="nav-link d-flex align-items-center"
                  style={{ 
                    padding: '5px 0',
                    color: isActive('addseo') ? '#059e98' : '#666',
                    fontWeight: isActive('addseo') ? '500' : '400',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#059e98';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = isActive('addseo') ? '#059e98' : '#666';
                  }}
                >
                  <FaPlus style={{ 
                    color: '#059e98',
                    marginRight: '6px',
                    fontSize: '0.75rem',
                    flexShrink: 0
                  }} />
                  New Seo Page
                </a>
                <a 
                  href="viewseo" 
                  className="nav-link d-flex align-items-center"
                  style={{ 
                    padding: '5px 0',
                    color: isActive('viewseo') ? '#059e98' : '#666',
                    fontWeight: isActive('viewseo') ? '500' : '400',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#059e98';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = isActive('viewseo') ? '#059e98' : '#666';
                  }}
                >
                  <FaEye style={{ 
                    color: '#059e98',
                    marginRight: '6px',
                    fontSize: '0.75rem',
                    flexShrink: 0
                  }} />
                  View SEO
                </a>
              </div>
            )}
          </li>

          {/* Hotel Section */}
          <li className="nav-item mb-2">
            <div 
              className="d-flex align-items-center justify-content-between"
              style={{
                cursor: 'pointer',
                borderRadius: '6px',
                padding: '8px 10px',
                background: activeDropdown === 'hotel' ? '#f8f9fa' : 'transparent',
                border: activeDropdown === 'hotel' ? '1px solid #e9ecef' : 'none',
                fontSize: '0.9rem',
                transition: 'all 0.2s ease'
              }}
              onClick={() => toggleDropdown('hotel')}
              onMouseEnter={(e) => {
                if (activeDropdown !== 'hotel') {
                  e.currentTarget.style.background = '#f8f9fa';
                }
              }}
              onMouseLeave={(e) => {
                if (activeDropdown !== 'hotel') {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              <div className="d-flex align-items-center">
                <FaHotel style={{ 
                  color: '#059e98', 
                  fontSize: '0.9rem',
                  marginRight: '8px',
                  flexShrink: 0
                }} />
                <span style={{ fontWeight: '500', color: '#333' }}>Hotel</span>
              </div>
              {activeDropdown === 'hotel' ? 
                <FaChevronDown size={11} color="#666" /> : 
                <FaChevronRight size={11} color="#666" />
              }
            </div>
            
            {activeDropdown === 'hotel' && (
              <div className="mt-1" style={{ fontSize: '0.85rem', paddingLeft: '26px' }}>
                <a 
                  href="addhotel" 
                  className="nav-link d-flex align-items-center"
                  style={{ 
                    padding: '5px 0',
                    color: isActive('addhotel') ? '#059e98' : '#666',
                    fontWeight: isActive('addhotel') ? '500' : '400',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#059e98';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = isActive('addhotel') ? '#059e98' : '#666';
                  }}
                >
                  <FaPlus style={{ 
                    color: '#059e98',
                    marginRight: '6px',
                    fontSize: '0.75rem',
                    flexShrink: 0
                  }} />
                  New Hotel
                </a>
                <a 
                  href="viewhotel" 
                  className="nav-link d-flex align-items-center"
                  style={{ 
                    padding: '5px 0',
                    color: isActive('viewhotel') ? '#059e98' : '#666',
                    fontWeight: isActive('viewhotel') ? '500' : '400',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#059e98';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = isActive('viewhotel') ? '#059e98' : '#666';
                  }}
                >
                  <FaList style={{ 
                    color: '#059e98',
                    marginRight: '6px',
                    fontSize: '0.75rem',
                    flexShrink: 0
                  }} />
                  Hotel List
                </a>
              </div>
            )}
          </li>

          {/* Package Section */}
          <li className="nav-item mb-2">
            <div 
              className="d-flex align-items-center justify-content-between"
              style={{
                cursor: 'pointer',
                borderRadius: '6px',
                padding: '8px 10px',
                background: activeDropdown === 'package' ? '#f8f9fa' : 'transparent',
                border: activeDropdown === 'package' ? '1px solid #e9ecef' : 'none',
                fontSize: '0.9rem',
                transition: 'all 0.2s ease'
              }}
              onClick={() => toggleDropdown('package')}
              onMouseEnter={(e) => {
                if (activeDropdown !== 'package') {
                  e.currentTarget.style.background = '#f8f9fa';
                }
              }}
              onMouseLeave={(e) => {
                if (activeDropdown !== 'package') {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              <div className="d-flex align-items-center">
                <FaBoxOpen style={{ 
                  color: '#059e98', 
                  fontSize: '0.9rem',
                  marginRight: '8px',
                  flexShrink: 0
                }} />
                <span style={{ fontWeight: '500', color: '#333' }}>Package</span>
              </div>
              {activeDropdown === 'package' ? 
                <FaChevronDown size={11} color="#666" /> : 
                <FaChevronRight size={11} color="#666" />
              }
            </div>
            
            {activeDropdown === 'package' && (
              <div className="mt-1" style={{ fontSize: '0.85rem', paddingLeft: '26px' }}>
                <a 
                  href="addpackage" 
                  className="nav-link d-flex align-items-center"
                  style={{ 
                    padding: '5px 0',
                    color: isActive('addpackage') ? '#059e98' : '#666',
                    fontWeight: isActive('addpackage') ? '500' : '400',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#059e98';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = isActive('addpackage') ? '#059e98' : '#666';
                  }}
                >
                  <FaPlus style={{ 
                    color: '#059e98',
                    marginRight: '6px',
                    fontSize: '0.75rem',
                    flexShrink: 0
                  }} />
                  New Packages
                </a>
                <a 
                  href="listpackage" 
                  className="nav-link d-flex align-items-center"
                  style={{ 
                    padding: '5px 0',
                    color: isActive('listpackage') ? '#059e98' : '#666',
                    fontWeight: isActive('listpackage') ? '500' : '400',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#059e98';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = isActive('listpackage') ? '#059e98' : '#666';
                  }}
                >
                  <FaList style={{ 
                    color: '#059e98',
                    marginRight: '6px',
                    fontSize: '0.75rem',
                    flexShrink: 0
                  }} />
                  Package List
                </a>
              </div>
            )}
          </li>

          {/* Logout */}
          <li className="nav-item mt-3 pt-3" style={{ borderTop: '1px solid #e9ecef' }}>
            <a 
              href='login' 
              className="nav-link d-flex align-items-center"
              style={{ 
                borderRadius: '6px',
                background: 'rgba(220, 53, 69, 0.08)',
                color: '#dc3545',
                fontWeight: '500',
                fontSize: '0.9rem',
                padding: '1px 10px',
                textDecoration: 'none'
              }} 
              onClick={() => localStorage.clear()}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(220, 53, 69, 0.12)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(220, 53, 69, 0.08)';
              }}
            >
              <FaSignOutAlt style={{ 
                marginRight: '25px',
                marginLeft: '10px',
                fontSize: '1.5rem',
                flexShrink: 0
              }} />
              Logout
            </a>
          </li>
        </ul>
      </div>
    </nav>
    </>
  )
}